import { FC, useContext } from "react";
import { GlobalContext } from "../../storage";
import styles from "./stepperNew.module.scss";

type StepperProps = {
  step: number;
};

const STEPS = [
  { label: 'STEP 1', title: '掃描歸還點' },
  { label: 'STEP 2', title: '掃描包裝編號' },
  { label: '完成', title: '完成歸還' },
];

const Stepper: FC<StepperProps> = ({ step }) => {
  const { returnStorage } = useContext(GlobalContext);
  // eslint-disable-next-line
  const { fami_tage, setFamiTage } = returnStorage;

  return (
    <div className={styles.stepper}>
      <div className={styles.progressTrack}>
        {STEPS.map((s, idx) => {
          const isDone = idx < step;
          const isActive = idx === step;
          return (
            <div key={idx} className={styles.stepGroup}>
              <div className={styles.stepItem}>
                <div
                  className={`${styles.dot} ${isDone ? styles.done : ''} ${
                    isActive ? styles.active : ''
                  }`}
                >
                  {isDone ? '✓' : idx + 1}
                </div>
                <div
                  className={`${styles.label} ${
                    isActive || isDone ? styles.labelActive : ''
                  }`}
                >
                  {s.label}
                </div>
              </div>
              {idx < STEPS.length - 1 && (
                <div
                  className={`${styles.connector} ${
                    idx < step ? styles.connectorDone : ''
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>

      <div className={styles.content}>
        {step === 0 && (
          <div className={styles.stepDesc}>
            <p className={styles.descTitle}>請掃描「歸還點」上的 QR Code</p>
            <ul>
              <li>
                全家便利商店：至 FamiPort 機台點選「服務寄件 {'>'} 循環袋退貨」，找到有配客嘉圖樣的「循環包材歸還」選項。
              </li>
              <li>其他歸還點：至店內找尋或詢問店員循環箱位置。</li>
            </ul>
          </div>
        )}
        {step === 1 && (
          <div className={styles.stepDesc}>
            <p className={styles.descTitle}>請掃描包裝上的「包裝編號 QR Code」</p>
          </div>
        )}
        {step === 2 && fami_tage !== true && (
          <div className={styles.stepDesc}>
            <p className={styles.descTitle}>點擊上方按鈕結束歸還，領取優惠</p>
          </div>
        )}
        {/* 舊「收納箱」店員提示已移除 —— 全家改走日翊退貨通(店員掃寄件 QR 交寄),
            正確交件引導改在寄件 QRC 畫面(FamiReturnQrc),此處不再顯示收納箱說明。 */}
      </div>
    </div>
  );
};

export default Stepper;
